import { Box, Button, Card, CardContent, Chip, Container, Grid, List, ListItem, ListItemText, Paper, Stack, TextField, Typography } from "@mui/material";
import PageProps from "../_types/page-props.interface";
import useDocumentTitle from "../hooks/useDocumentTitle";
import { StyleHelper } from "../components/style-helper";
import { useGlobalState } from "../context/global";
import { FormEvent, useEffect, useState } from "react";
import { useError } from "../context/error";
import { StreamService } from "../services/stream.service";
import CarnivoreLogo from "../components/imgs/carnivore-logo";
import IvsVideoJsPlayer from "../components/axxess/video-player";
import ElapsedTimeChip from "../components/elapsed-time";
import { useTextInput } from "../hooks/useTextField";
import { DiamondOutlined, SendOutlined } from "@mui/icons-material";
import LoadingButton from "../components/controls/loading-btn";
import { useSuccess } from "../context/success";
import MessageSender from "../components/axxess/message-sender";
import { useStreamStatus } from "../context/streamStatus.context";
import Grid2 from "@mui/material/Unstable_Grid2";
import { PastStream } from "../_types/stream-status.type";
import PastStreamCard from "../components/axxess/past-stream-card";
import StreamVideoModal from "../components/modals/stream-video.modal";

export default function AxxessPage(props: PageProps) {
    useDocumentTitle(props.title)

    const { streamStatus } = useStreamStatus()
    const [link, setLink] = useState('')
    const { setError } = useError()
    const streamService = new StreamService(setError)
    const [loading, setLoading] = useState(false)
    const [recentStreams, setRecentStreams] = useState<PastStream[]>([])
    const [sessionId, setSessionId] = useState('')
    const [selectedStream, setSelectedStream] = useState<PastStream | null>(null)
    const [videoModalOpen, setVideoModalOpen] = useState(false)


    useEffect(() => {
        streamService.getRecent().then(data => {
            if (data.pastStreams) {
                setRecentStreams(data.pastStreams)
            }
        })
    }, [])

    useEffect(() => {
        if (streamStatus.state === 'LIVE' && !link) {
            _getLink()
        }
    }, [streamStatus])

    const _getLink = async (retry: boolean = true) => {
        setLoading(true)
        const statusRes = await streamService.getStreamStatus()
        if (statusRes.status) {

            if (statusRes.status.state === 'LIVE') {

                const linkRes = await streamService.getStreamLink()
                if (linkRes.signedUrl) {
                    setLink(linkRes.signedUrl)
                    if (statusRes.status.streamId) {
                        setSessionId(statusRes.status.streamId)
                    }
                } else {
                    if (retry) {
                        await new Promise((resolve) => {
                            setTimeout(() => {
                                resolve(null)
                            }, 3000)
                        })
                        _getLink(false)
                        console.log(`RETRYING ===============>`)
                    } else {
                        setError(`An Error occurred loading the stream, try refreshing the page`)
                    }

                }
            }
        }
        setLoading(false)

    }



    return <Container sx={{ display: 'flex', flexDirection: 'column', pb: 4 }}>
        <Grid container>
            <Grid item xs={12} lg={10}>
                <Box display='flex' alignItems='center' gap={2}>
                    <Typography variant='h4'>Direct Axxess</Typography>
                </Box>

            </Grid>
            <StyleHelper.VerticalSpace />





        </Grid>
        {!loading && <>
            {streamStatus.state !== 'LIVE' && <>
                {/* <Paper elevation={3}>
                        <Box p={3}>
                            <Grid container justifyContent={'center'}>
                                <Grid item md={1} xs={3}>
                                    <CarnivoreLogo />

                                </Grid>
                            </Grid>
                            <StyleHelper.VerticalSpace />
                            <Typography variant="h4" textAlign={'center'}>Check back Later</Typography>
                            <StyleHelper.VerticalSpace />
                            <Typography textAlign={'center'}>Dutch has spoken. The alert is either sent or coming in hot. Stay tuned for the next live stream.  </Typography>
                            <Typography textAlign={'center'}>This page will automatically refresh when Dutch is live again.</Typography>


                        </Box>
                    </Paper> */}
                <Grid2 container spacing={3}>
                    <Grid2 md={8}>
                        <Paper elevation={3}>
                            <Box p={3}>
                                <Chip label='Offline' color="primary" />
                                <StyleHelper.SmallVerticalSpace />
                                <Typography variant="h5">Dutch is Currently Offline</Typography>
                                <StyleHelper.VerticalSpace />
                                <Typography variant="body2">  Thank you for being a Direct Axxess member. This page will automatically refresh when Dutch is streaming and live again.</Typography>
                            </Box>
                        </Paper>
                    </Grid2>
                    <Grid2 md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            }}
                        >
                            <Box p={3}>
                                <Typography variant="subtitle1" color="text.secondary" gutterBottom>
                                    Your Direct Line
                                </Typography>
                                <Typography
                                    variant="h5"
                                    color="primary"
                                    fontWeight="bold"
                                    component="a"
                                    href="tel:4048019750"
                                    sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                                >
                                    (404) 801-9750
                                </Typography>
                                <StyleHelper.SmallVerticalSpace />
                                <Typography variant="body2" >
                                    Do not share this number. This is your private line to our trading desk.
                                </Typography>
                            </Box>
                        </Paper>

                    </Grid2>
                </Grid2>
            </>}


            {streamStatus.state === 'LIVE' && <>
                <Paper elevation={3} sx={{ width: '100%' }}>
                    <Box p={3} width={"100%"}>
                        {link && <IvsVideoJsPlayer streamUrl={link} onError={async () => { console.log('Errored out') }} />}
                        <StyleHelper.VerticalSpace />
                        <Typography variant="subtitle1" fontWeight={'bold'}>
                            Dutch is Live
                        </Typography>
                        <Typography>Started at {new Date(streamStatus.startTime ?? "").toLocaleTimeString('en-US', { timeStyle: 'short' })}</Typography>
                        <ElapsedTimeChip startDate={streamStatus.startTime ?? ""} />
                        <StyleHelper.VerticalSpace />
                        <Typography variant="body2">Not hearing audio? Try unmuting. </Typography>
                    </Box>
                </Paper>
            </>}
            <MessageSender />


        </>}
        <StyleHelper.VerticalSpace />
        <Grid2 container>

            <Grid2 md={10}>
                <Paper elevation={3}>
                    <Box p={3}>

                        <Typography variant="h5">How it Works</Typography>
                        <StyleHelper.VerticalSpace />
                        <List
                            component="ol"
                            sx={{
                                listStyleType: 'decimal',
                                pl: 2,              // indent to align numbers
                                '& li': {
                                    display: 'list-item'
                                }
                            }}
                        >
                            <ListItem component="li">
                                <ListItemText primary="Dutch goes live from the trading desk and starts a private stream." />
                            </ListItem>
                            <ListItem component="li">
                                <ListItemText primary="You'll receive a mobile notification the moment the stream begins—no need to refresh." />
                            </ListItem>
                            <ListItem component="li">
                                <ListItemText primary="If you're on this page, it will instantly update to show Dutch live without any action needed." />
                            </ListItem>
                            <ListItem component="li">
                                <ListItemText primary="Be the first to know. You'll see and hear trade alerts in near real-time—before they're typed and emailed to the rest of the Carnivores." />
                            </ListItem>
                            <ListItem component="li">
                                <ListItemText primary="Send messages directly to Dutch. Ask questions or share quick thoughts during the stream—this is a one-way line straight to him." />
                            </ListItem>
                            <ListItem component="li">
                                <ListItemText primary="If Dutch isn't streaming, you can call the private trading desk number anytime during market hours." />
                            </ListItem>
                        </List>
                    </Box>
                </Paper>
            </Grid2>
        </Grid2>
        <StyleHelper.VerticalSpace />
        {recentStreams?.length > 0 && <Paper elevation={3}>
            <Box p={3}>
                <Typography variant="h5" gutterBottom>Recent Streams</Typography>
                <StyleHelper.SmallVerticalSpace />
                <Grid2 container spacing={2}>
                    {recentStreams.map(stream => (
                        <Grid2 key={stream.id} xs={12} sm={6} md={4}>
                            <PastStreamCard
                                stream={stream}
                                onClick={() => {
                                    setSelectedStream(stream)
                                    setVideoModalOpen(true)
                                }}
                            />
                        </Grid2>
                    ))}
                </Grid2>
            </Box>
        </Paper>}

        {/* Video Modal for Past Streams */}
        {selectedStream && (
            <StreamVideoModal
                open={videoModalOpen}
                onClose={() => {
                    setVideoModalOpen(false)
                    setSelectedStream(null)
                }}
                videoUrl={selectedStream.videoUrl}
                title={`Stream - ${new Date(selectedStream.start).toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                })}`}
            />
        )}

    </Container >
}
